import React, { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Consecutive,
  Document,
  Label,
  Button,
  FormGroup,
  stylesSelect,
  Error,
} from "./style";

import { TypesLoading } from "@context/types/loading";
//Components
import Select from "@components/form/Select";
import { IOptions } from "@components/form/Select/interface";
import { getDocumentType } from "@api/services/parameterization";
import { findIssu } from "@api/services/issues";
import { AppContext } from "@context";

export interface IFormIssue {
  docType: IOptions;
  document: string;
  serial: string;
}
const SearchCase = () => {
  const history = useHistory();
  const [doctype, setDoctype] = useState<IOptions[]>([]);
  const methods = useForm();
  const { state, dispatch } = useContext(AppContext);
  const { register, handleSubmit, errors, control, setValue, watch } = methods;
  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: TypesLoading.Loading });
        const responseDocumentype = await getDocumentType();
        const doctypes = responseDocumentype.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        setDoctype(doctypes);
        dispatch({ type: TypesLoading.NotLoading });
      } catch (e) {
        dispatch({ type: TypesLoading.NotLoading });
      }
    })();
  }, []);

  const submit = async ({ docType, document, serial }: IFormIssue) => {
    const issue = {
      docType: docType.value,
      document,
      serial,
    };
    try {
      dispatch({ type: TypesLoading.Loading });
      const response = await findIssu(issue);
      const location = {
        pathname: "/view",
        state: { ...response, serial },
      };
      dispatch({ type: TypesLoading.NotLoading });
      history.push(location);
    } catch {
      dispatch({ type: TypesLoading.NotLoading });
      toast.error("No encontramos una PQRS con los datos ingresado.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <Container onSubmit={handleSubmit(submit)}>
      <Label>Consulta el Estado de tu Caso</Label>
      <FormGroup>
        <Controller
          as={Select}
          options={doctype}
          placeholder={"Elije un tipo"}
          name={"docType"}
          control={control}
          rules={{ required: true }}
          styles={stylesSelect}
        />
        {errors.docType?.type === "required" && <Error>Es requerido</Error>}
      </FormGroup>
      <FormGroup>
        <Document
          placeholder={"Número de cédula"}
          name={"document"}
          ref={register({ required: true })}
        />
        {errors.document?.type === "required" && <Error>Es requerido</Error>}
      </FormGroup>
      <FormGroup>
        <Consecutive
          placeholder={"Número del consecutivo"}
          name={"serial"}
          ref={register({ required: true })}
        />
        {errors.serial?.type === "required" && <Error>Es requerido</Error>}
      </FormGroup>
      <Button type="submit">Consultar</Button>
    </Container>
  );
};

export default SearchCase;
